<template>
  <div class="modal__wrapper">
    <div class="modal" :class="[domclass, getClasses]" >
      <div class="modal__content" ref="modalContent">
        <slot />
      </div>
    </div>
    <div class="modal--background"></div>
  </div>
</template>
<script lang="ts" setup>
  import { ref, onMounted, computed } from 'vue'

  const props = defineProps({
    domclass: {
      type: String,
      default: ''
    },
    scrollBoundary: {
      type: Number,
      default: 10
    }
  })

  const getClasses = computed(() => {
    return longContent.value ? 'modal--scroll' : ''
  })

  onMounted(() => {
    const height = modalContent.value.clientHeight
    const percentageInPixels = (window.innerHeight * (props.scrollBoundary / 100))

    if (height > (window.innerHeight - percentageInPixels)) {
      longContent.value = true
    }
  })

  const modalContent = ref()
  const longContent = ref(false)

</script>